export default __webpack_public_path__ + "static/media/succulent5.8d25cb08.jpg";